import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[36%] shrink-0">
            <span className="text-xs md:text-sm font-semibold tracking-widest text-accent-700 uppercase">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              常见问题解答
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              把关于「善良的女秘书」网盘资源、迅雷下载、磁力链接与种子资源的高频疑问集中整理在这里，
              点击问题即可展开对应解答。
            </p>
            <div className="mt-6 rounded-lg bg-background-50 border border-background-200 p-5">
              <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className="ri-information-line text-primary-600"></i>
                还有别的疑问？
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                可以先回到「渠道详解」与「四步查询流程」查看具体说明，多数问题在那里已经覆盖。
              </p>
            </div>
          </div>

          <div className="flex-1 space-y-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className={`rounded-lg border bg-background-50 overflow-hidden transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                        {faq.q}
                      </span>
                      <i
                        className={`shrink-0 text-lg ${
                          isOpen ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-500"
                        }`}
                      ></i>
                    </button>
                  </h3>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}